import { getAxiosInstance } from '../client';
/** Typed API functions for exercise programs */
export const exerciseProgramsQueries = {
    /** GET /exercise-programs/:id */
    getById: (id) => getAxiosInstance()
        .get(`/exercise-programs/${id}`)
        .then((r) => r.data),
    /** GET /users/:userId/exercise-programs */
    getByUser: (userId) => getAxiosInstance()
        .get(`/users/${userId}/exercise-programs`)
        .then((r) => r.data),
    /** GET /exercise-programs/:id/has-training-sessions */
    hasTrainingSessions: (id) => getAxiosInstance()
        .get(`/exercise-programs/${id}/has-training-sessions`)
        .then((r) => r.data),
    /** GET /exercise-programs/:id/calendar/start/:start/end/:end */
    getCalendar: (id, start, end) => getAxiosInstance()
        .get(`/exercise-programs/${id}/calendar/start/${start}/end/${end}`)
        .then((r) => r.data),
    /** GET /exercise-programs/created-by-therapist/:therapistId */
    getCountCreatedByTherapist: (therapistId) => getAxiosInstance()
        .get(`/exercise-programs/created-by-therapist/${therapistId}`)
        .then((r) => r.data),
    getByUserWithStats: (userId) => getAxiosInstance()
        .get(`/users/${userId}/exercise-programs/with-stats`)
        .then((r) => r.data),
};
/** Query keys for exercise programs - use with TanStack Query */
export const exerciseProgramsKeys = {
    all: () => ['exercise-programs'],
    byId: (id) => ['exercise-programs', id],
    byUser: (userId) => ['exercise-programs', 'user', userId],
    countCreatedByTherapist: (therapistId) => ['exercise-programs', 'createdByTherapist', therapistId],
    hasTrainingSessions: (id) => ['exercise-programs', id, 'has-training-sessions'],
    byUserWithStats: (userId) => ['exercise-programs', 'user', userId, 'with-stats'],
};
//# sourceMappingURL=exercise-programs.queries.js.map